import { useState } from 'react';
import { BlockButton } from '@/components/BlockButton';
import type { JobChangeProcess } from '../../types/JobChangeProcess';
import { showErrorToast, showSuccessToast } from '../../lib/toast';
import useUpdateJobChangeProcess from '../../api/useUpdateJobChangeProcess';

type Props = {
  jobChangeProcess: JobChangeProcess;
  close: () => void;
  jobchangeProcessesRefetch: () => Promise<void>;
};

export default function StatusDeclineModalContents({
  jobChangeProcess,
  close,
  jobchangeProcessesRefetch,
}: Props) {
  const [isSubmit, setIsSubmit] = useState(false);
  const { mutateAsync } = useUpdateJobChangeProcess();

  const candidateName = jobChangeProcess.candidate_profile?.name ?? '';
  const companyName = jobChangeProcess.company?.name ?? '';

  const onSubmit = async () => {
    setIsSubmit(true);
    try {
      await mutateAsync({
        jobChangeProcessId: jobChangeProcess.id,
        latestLogId: jobChangeProcess.latest_log?.id ?? 0,
        result: 'declined',
        interviewed_at: null,
      });
      showSuccessToast('ステータスを変更しました');
    } catch (error) {
      showErrorToast('ステータスの変更に失敗しました');
    } finally {
      await jobchangeProcessesRefetch();
      setIsSubmit(false);
      close();
    }
  };

  return (
    <div className="w-[640px] bg-white">
      <div className="px-6 py-4">
        <p className="text-base font-bold">
          {candidateName} × {companyName}
        </p>
      </div>
      <div className="border-y border-solid border-border px-6 py-4">
        <p className="text-base">ステータスを「求職者辞退」に変更しますか？</p>
      </div>
      <div className="flex justify-end gap-4 px-6 py-4">
        <div className="w-[94px]">
          <BlockButton
            disabled={isSubmit}
            colorType="white"
            type="button"
            text="キャンセル"
            onClick={close}
          />
        </div>
        <div className="w-[136px]">
          <BlockButton
            disabled={isSubmit}
            colorType="red"
            type="button"
            text="求職者辞退に変更"
            onClick={onSubmit}
          />
        </div>
      </div>
    </div>
  );
}
